<template>
    <div>
        <div class="container u-header__hide-content pt-2">
            <div class="d-flex align-items-center">

                <div class="ml-auto">
                    <!-- Links -->
                    <div class="d-none d-sm-inline-block ml-sm-auto">
                        <ul class="list-inline mb-0">
                            <li class="list-inline-item mr-0">
                                <a class="u-header__navbar-link" href="https://almeki.io" target="_blank">Aide</a>
                            </li>
                            <li class="list-inline-item mr-0">
                                <a class="u-header__navbar-link" href="https://almeki.io" target="_blank">Contacts</a>
                            </li>
                            <!-- Account-->
                            <li v-if="user.authToken && user.info" class="list-inline-item">
                                <!-- Account Sidebar Toggle Button -->
                                <a id="sidebarNavToggler" class="btn btn-xs btn-text-secondary u-sidebar--account__toggle-bg ml-1 target-of-invoker-has-unfolds" href="javascript:" role="button" aria-controls="sidebarContent" aria-haspopup="true" aria-expanded="false" data-unfold-event="click" data-unfold-hide-on-scroll="false" data-unfold-target="#sidebarContent" data-unfold-type="css-animation" data-unfold-animation-in="fadeInRight" data-unfold-animation-out="fadeOutRight" data-unfold-duration="500">
                                    <span class="position-relative">
                                      <span class="u-sidebar--account__toggle-text">{{ user.info.profile.displayName }}</span>
                                      <img class="u-sidebar--account__toggle-img"
                                           :src="avatarDisplayUrl" alt="Image Description">
<!--                                      <span class="badge badge-sm badge-success badge-pos rounded-circle">3</span>-->
                                    </span>
                                </a>
                                <!-- End Account Sidebar Toggle Button -->

                                <AccountSidebarNav/>

                                <script type="application/javascript" v-bind:src="hsUnfoldSrc"></script>
                                <script type="application/javascript" v-bind:src="hsPluginsInitSrc"></script>
                            </li>
                            <!-- End Account-->
                        </ul>
                    </div>
                    <!-- End Links -->
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {mapState} from "vuex";
    import AccountSidebarNav from "./AccountSidebarNav";
    import {ASSETS_FOLDER} from "../settings";
    import {JS_FILES} from "../settings/scripts";

    export default {
        name: "TopBar",
        components: {AccountSidebarNav},
        data() {
            return {
                hsUnfoldSrc: JS_FILES.hs.unfold,
                hsPluginsInitSrc: JS_FILES.hs.pluginsInit.unfold
            }
        },
        computed: {
            ...mapState([
                'user'
            ]),
            avatarDisplayUrl: function () {
                const avatarUrl = this.$store.state.user.info.profile.avatarUrl;
                return avatarUrl ? avatarUrl : `${ASSETS_FOLDER}/img/100x100/anonymous_user.png`
            }
        }
    }
</script>

<style scoped>

</style>